module.exports = __webpack_public_path__ + "img/step.6df1c748.png";